import { merge } from 'lodash';
import { BaseClient as InfraBaseClient } from 'vue-infra';
import Config from '@config/config';
import { RESOURCES_CONFIGURATION_TIMEOUT as TIMEOUT } from '@config/Consts';
import BaseClient from '@core/common/BaseClient';

const EVENTS = BaseClient.EVENTS;

const RESOURCES = {
  MESSAGING_CURRENT_QUEUE_HEALTH: 'messagingCurrentQueueHealth',
  MESSAGING_CSAT_DISTRIBUTIONS: 'messagingCsatDistribution',
  MESSAGING_CONVERSATIONS: 'messagingConversation',
  AGENT_ACTIVITY: 'agentActivity',
};

const RESOURCES_CONFIGURATION = {
  [RESOURCES.MESSAGING_CURRENT_QUEUE_HEALTH]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'ReportingData.MessagingCurrentQueueHealth',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'ReportingData.MessagingCsatDistribution',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.MESSAGING_CONVERSATIONS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'ReportingData.MessagingConversation',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.AGENT_ACTIVITY]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'ReportingData.AgentActivity',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
};

function createInfraBaseClient(options, config) {
  const { baseURL, apiResource } = BaseClient.urlResolver.resolveUrl(RESOURCES_CONFIGURATION[config.resource]);

  const infraBaseClientOptions = {
    allowedMethods: RESOURCES_CONFIGURATION[config.resource].ALLOWED_METHODS,
    config: {
      baseURL,
      timeout: RESOURCES_CONFIGURATION[config.resource].TIMEOUT,
    },
    source: {
      appName: Config.moduleName,
      contextName: config.contextName,
    },
    body: {
      v: apiResource.version,
    },
    retryConfig: BaseClient.getClientRetryConfig,
  };
  merge(infraBaseClientOptions, options);
  return new InfraBaseClient(infraBaseClientOptions);
}

class ReportingClient extends BaseClient {
  /*
  @param options {resource, infraBaseClientConfig}
 */
  constructor({
    infraBaseClientOptions,
    ...options
  }) {
    const infraBaseClient = createInfraBaseClient(infraBaseClientOptions, options);
    super({
      name: 'ReportingClient',
      infraBaseClient,
      ...options,
    });
  }
}

ReportingClient.EVENTS = EVENTS;

export {
  RESOURCES,
  EVENTS,
  ReportingClient,
};
